// Logger de la aplicación.
/* eslint-disable no-console */

const isDebugEnabled = () => {
  if (typeof process === 'undefined' || !process.env) return true;
  const { REACT_APP_ENABLE_DEBUG } = process.env;
  return REACT_APP_ENABLE_DEBUG === 'true';
};

const createLogger = () => {
  const enabled = isDebugEnabled();

  return {
    debug: enabled ? (...args) => console.debug('[DEBUG]', ...args) : () => {},
    log: enabled ? (...args) => console.log('[LOG]', ...args) : () => {},
    info: enabled ? (...args) => console.info('[INFO]', ...args) : () => {},
    warn: (...args) => console.warn('[WARN]', ...args),
    error: (...args) => console.error('[ERROR]', ...args),
  };
};

const logger = createLogger();

export default logger;
export { createLogger };
